// import React from "react";
// import { motion } from "motion/react";
// import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
// const PrekSection = ({ index, content, title, image }) => {
//   const isMobile = useMediaQuery("(max-width:600px)");

//   const styles = {
//     container: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       minHeight: "100vh",
//       padding: isMobile ? "2rem" : "6rem 6rem",
//       backgroundColor: "#F7F3FC",
//     },
//     // Pre-K Section Styles
//     preKContainer: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexDirection: isMobile ? "column" : "row",
//       padding: isMobile ? "1rem" : "3rem 6rem",
//       backgroundColor: "#F7F3FC",
//       position: "relative",
//       marginBottom: isMobile ? "2rem" : "8rem",
//     },
//     // grayBox: {
//     //   width: isMobile ? "90%" : "350px",
//     //   height: isMobile ? "180px" : "280px",
//     //   // backgroundColor: "#D3D3D3",
//     //   borderRadius: "40px",
//     //   position: "absolute",
//     //   left: isMobile ? "40%" : "55%", // Moves gray box more to the right
//     //   top: "50%",
//     //   zIndex: 3,
//     // },
//     grayBox: {
//       width: isMobile ? "90%" : "350px",
//       height: isMobile ? "180px" : "280px",
//       backgroundImage: `url(${image})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       borderRadius: "40px",
//       position: "absolute",
//       left: isMobile ? "40%" : "55%",
//       top: "50%",
//       zIndex: 3,
//       transform: "translate(-50%, -50%)",
//     },
//     redBox: {
//       backgroundColor: "#336599",
//       color: "#FFFFFF",
//       width: "100%",
//       padding: isMobile ? "1rem" : "2rem",
//       borderRadius: "20px",
//       maxWidth: isMobile ? "90%" : "100%",
//       height: isMobile ? "90%" : "150px",
//       position: "relative",
//       zIndex: 2,
//     },
//     boldText: {
//       fontWeight: "bold",
//       fontSize: isMobile ? "16px" : "20px",
//     },
//   };

//   const isEven = (i) => {
//     return i % 2 == 0;
//   };
//   return (
//     <motion.div
//       initial={
//         isEven(index || 0) ? { opacity: 0, x: -300 } : { opacity: 0, x: 300 }
//       }
//       whileInView={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.8 }}
//       viewport={{ once: true }}
//     >
//       <Box sx={styles.preKContainer}>
//         <Box
//           sx={{ ...styles.grayBox, transform: "translate(-140%,-50%)" }}
//         ></Box>
//         <Box
//           sx={{
//             ...styles.redBox,
//             display: "flex",
//             justifyContent: "end",
//             textAlign: "start!important",
//           }}
//         >
//           <Box sx={{ width: "50%" }}>
//             <Typography sx={styles.boldText}>{title}</Typography>
//             <Typography sx={{ marginTop: "2%" }}>{content}</Typography>
//           </Box>
//         </Box>
//       </Box>
//     </motion.div>
//   );
// };

// export default PrekSection;

import React from "react";
import { motion } from "motion/react";
import { Box, Typography, useMediaQuery } from "@mui/material";

const PrekSection = ({ index, content, title, image }) => {
  const isMobile = useMediaQuery("(max-width:900px)"); // Covers both mobile and tablets

  const styles = {
    preKContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: isMobile ? "column" : "row",
      padding: isMobile ? "1rem" : "3rem 6rem",
      backgroundColor: "#F7F3FC",
      position: "relative",
      marginBottom: isMobile ? "2rem" : "8rem",
    },
    grayBox: {
      width: isMobile ? "90%" : "350px",
      height: isMobile ? "180px" : "280px",
      backgroundImage: `url(${image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "40px",
      position: isMobile ? "relative" : "absolute",
      left: isMobile ? "auto" : "55%",
      top: isMobile ? "auto" : "50%",
      zIndex: 3,
      transform: isMobile ? "none" : "translate(-50%, -50%)",
      marginBottom: isMobile ? "1rem" : 0,
    },
    redBox: {
      backgroundColor: "#336599",
      color: "#FFFFFF",
      width: "100%",
      padding: isMobile ? "1rem" : "2rem",
      borderRadius: "20px",
      maxWidth: isMobile ? "90%" : "100%",
      height: isMobile ? "auto" : "150px",
      position: "relative",
      zIndex: 2,
      textAlign: "start",
    },
    boldText: {
      fontWeight: "bold",
      fontSize: isMobile ? "16px" : "20px",
    },
  };

  const isEven = (i) => {
    return i % 2 === 0;
  };

  return (
    <motion.div
      initial={
        isEven(index || 0) ? { opacity: 0, x: -300 } : { opacity: 0, x: 300 }
      }
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <Box sx={styles.preKContainer}>
        {isMobile ? (
          <>
            <Box sx={styles.grayBox}></Box>
            <Box sx={styles.redBox}>
              <Typography sx={styles.boldText}>{title}</Typography>
              <Typography sx={{ marginTop: "2%" }}>{content}</Typography>
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                ...styles.grayBox,
                transform: "translate(-140%, -50%)",
              }}
            ></Box>
            <Box
              sx={{
                ...styles.redBox,
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <Typography sx={styles.boldText}>{title}</Typography>
                <Typography sx={{ marginTop: "2%" }}>{content}</Typography>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </motion.div>
  );
};

export default PrekSection;


